var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: { entity: "systemPage", id: _vm.id, "use-sharing": false },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "text-h5" }, [
                      _vm._v(_vm._s(doc.name))
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", { domProps: { innerHTML: _vm._s(doc.details) } })
                  ])
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }